import { createTheme } from '@mui/material/styles';

// Ensure proper import resolution

// Create theme function that accepts direction
export const createAppTheme = (direction = 'ltr') => {
  const isRTL = direction === 'rtl';
  
  return createTheme({
    direction: isRTL ? 'rtl' : 'ltr',
    palette: {
      primary: {
        main: '#cc4924',
        light: '#f5e1d7',
        dark: '#bd3432',
        contrastText: '#fff',
      },
      secondary: {
        main: '#292b6b',
        light: '#ecebf6',
        dark: '#002852',
        contrastText: '#fff',
      },
      error: {
        main: '#bd3432',
        light: '#f5e1d7',
      },
      success: {
        main: '#85c656',
        light: '#eaf5d7',
      },
      warning: {
        main: '#ef7e1c',
      },
      info: {
        main: '#4e4e59',
      },
      grey: {
        50: '#fafafa',
        100: '#f4f4f5',
        200: '#e4e4e7',
        300: '#d4d4d8',
        400: '#a1a1aa',
        500: '#71717a',
        600: '#52525b',
        700: '#3f3f46',
        800: '#27272a',
        900: '#18181b',
      },
      background: {
        default: '#ffffff',
        paper: '#ffffff',
      },
      text: {
        primary: '#18181b',
        secondary: '#71717a',
      },
    },
    typography: {
      fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
      h1: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 700,
      },
      h2: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 700,
      },
      h3: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 600,
      },
      h4: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 600,
      },
      h5: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 600,
      },
      h6: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 600,
      },
      body1: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 400,
      },
      body2: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 400,
      },
      button: {
        fontFamily: '"Poppins", sans-serif',
        fontWeight: 500,
        textTransform: 'none',
      },
    },
    shape: {
      borderRadius: 0, // Sharp corners as per your requirement
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 0,
            textTransform: 'none',
            fontWeight: 500,
            padding: '0.75rem 1.5rem',
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              borderRadius: 0,
              '& fieldset': {
                borderColor: '#d4d4d8',
              },
              '&:hover fieldset': {
                borderColor: '#a1a1aa',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#cc4924',
                borderWidth: '1px',
              },
            },
            '& .MuiInputBase-input': {
              borderRadius: 0,
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            borderRadius: 0,
            '&.Mui-focused': {
              borderRadius: 0,
            },
          },
          input: {
            borderRadius: 0,
            '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
              WebkitAppearance: 'none',
              appearance: 'none',
              margin: 0,
              display: 'none',
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            borderRadius: 0,
            '&.Mui-focused': {
              borderRadius: 0,
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d4d4d8',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#a1a1aa',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#cc4924',
              borderWidth: '1px',
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 0,
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 0,
          },
        },
      },
      MuiModal: {
        styleOverrides: {
          root: {
            '& .MuiBackdrop-root': {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 0,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 0,
          },
        },
      },
    },
  });
};

